import React, { FC } from "react";

const MenuEntry: FC = ({ children }) => <li>{children}</li>;

export default MenuEntry;
